<template>
  <div>
    <div class="flex justify-end cursor-pointer"
         @click="$emit('update:showHelptext', false)">
      <i class="fal fa-times text-lg"></i>
    </div>
    <div class="font-semibold mb-3">
      {{ helptextHeadline }}
    </div>
    <div class="font-light">
      {{ helptext }}
    </div>
    <div v-if="helptextHeadlineTwo" class="font-semibold mt-6 mb-3">
      {{ helptextHeadlineTwo }}
    </div>
    <div v-if="helptextTwo" class="font-light">
      {{ helptextTwo }}
    </div>
  </div>
</template>

<script setup>

defineProps({
  helptextHeadline: {
    type: String,
    default: "Fehler"
  },
  helptextHeadlineTwo: {
    type: String,
  },
  helptext: {
    type: String,
    default: "Beim Aufrufen des Inhaltes dieser Textbox ist ein Fehler aufgetreten."
  },
  helptextTwo: {
    type: String,
  },
  showHelptext: {
    type: Boolean,
  },
});

</script>
